import {IMG_URL} from '@/config/config'

export default {
  getPic(url) {
    return IMG_URL + url
  }
}



// WEBPACK FOOTER //
// ./src/utils/filters.js